"use client";

import * as images from "@/components/images/Images_second";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import { memo } from "react";

export const TermsContent = () => {
  return (
    <section className="section bg-white">
      <div className="container lg:!max-w-[824] mx-auto py-12 lg:py-20 text-gray-600 text-base leading-[160%] lg:leading-[150%] space-y-4 lg:space-y-6">
        <h2 className="text-xs leading-[150%] uppercase font-medium tracking-[0.6px] lg:text-base lg:leading-[150%] lg:normal-case lg:font-normal lg:tracking-normal">
          Privacy Policy
        </h2>

        <p>
          Welcome to the Languex website (collectively, the “Site”). This Site
          is owned and operated by Languex created to provide information about
          our translation
          <br />
          services and company. This Privacy Policy sets forth Languex’s policy
          with respect to information, including personally identifiable data
          and other information that is collected from Site visitors and users
          of our services.
        </p>
        <p>
          Information We Collect When you interact with us through the Site we
          may collect Personal Data and other information from you such as what
          you provide
          <br />
          voluntarily via registration, request for a quote or by ordering our
          services. By voluntarily providing us with Personal Data, you are
          consenting to our use of it in accordance with this Privacy Policy. If
          you provide Personal Data, you acknowledge and agree that such
          Personal Data may be transferred from your current location to the
          offices and servers of Languex and any authorized third parties.
        </p>

        <h3>Non-Identifiable Data</h3>
        <p>
          When you interact with Languex through our website we receive and
          store certain non-identifiable information. Such information, which is
          collected passively
          <br />
          using various technologies, cannot presently be used to specifically
          identify you. Languex may store such information itself or such
          information may be included in databases owned and maintained by
          Languex affiliates, agents or service providers. This Site may use
          such information and pool it with other information to track, for
          example, the total number of visitors to our Site, the number of
          visitors to each page of our Site, the domain names of our visitors’
          Internet service providers, and how our users use and interact with
          the services.
        </p>
        <p>
          Also, in an ongoing effort to better understand and serve our users,
          Languex often conducts research on its customer demographics,
          interests and behavior based on Personal Data and other information.
          This research may be compiled and analyzed on an aggregate basis.
          Languex may share this non-identifiable and aggregate data with its
          affiliates, agents and business partners, but this type of
          non-identifiable and aggregate information does not identify you
          personally. Languex may also disclose aggregated user statistics in
          order to describe our services to current and prospective business
          partners, and to other third parties for other lawful purposes.
        </p>
        <p>
          In operating this Site, we may also use a technology called “cookies.”
          A cookie is a piece of information that the computer that hosts our
          Site gives to your browser when you access the Site. Cookies provide
          additional functionality to the Site (such as remembering your user
          name) and assist us in analyzing Site usage more accurately. In all
          cases in which we use cookies, we will not collect Personal Data
          except with your permission. We recommend that you leave cookies
          turned on because they allow you to take advantage of some of the
          Site’s features.
        </p>

        <h3>Our Use of Your Personal Data and Other Information</h3>
        <p>
          Languex uses the Personal Data you provide in a manner that is
          consistent with this Privacy Policy. If you provide Personal Data for
          a certain reason, we may
          <br />
          use the Personal Data in connection with the reason for which it was
          provided. For instance, if you contact us by email, we will use the
          Personal Data you provide
          <br />
          to answer your question or resolve your problem. Also, if you provide
          Personal Data in order to obtain access to the services, we will use
          your Personal Data to provide you with access to such services and to
          monitor your use of such services. Languex, its subsidiaries and
          affiliates may also use your Personal Data and other personally
          <br />
          non-identifiable information collected through the Site to help us
          improve the content and functionality of the Site and to better
          understand our users and to
          <br />
          improve the services.
        </p>
        <p>
          Languex may use this information to communicate with you regarding
          services or to tell you about services we believe will be of interest
          to you. If we do so, each marketing communication we send you will
          contain instructions permitting you to “opt-out” of receiving future
          marketing communications. Note however that as user of the Service you
          cannot opt-out of some administrative communications that are
          reasonably necessary to the Service, such as billing or service
          notifications. In addition, if at any time you wish not to receive any
          future marketing communications or you wish to have your name deleted
          from our mailing lists, please contact us.
        </p>
        <p>
          If Languex intends on using any Personal Data in any manner that is
          not consistent with this Privacy Policy, you will be informed of such
          anticipated use prior to or at the time at which the Personal Data is
          collected.
        </p>

        <h3>Our Disclosure of Your Personal Data and Other Information</h3>
        <p>
          Languex is not in the business of selling your information. We
          consider this information to be a vital part of our relationship with
          you. There are, however, certain circumstances in which we may share
          your Personal Data with certain third parties without further notice
          to you, as set forth below:
        </p>
        <ul className="list-disc space-y-2 pl-5.5 [&>li]:marker:text-[90%] lg:space-y-0">
          <li>
            <span>Business Transfers:</span> As we develop our business, we
            might sell or buy businesses or assets. In the event of a corporate
            sale, merger, reorganization, dissolution or similar event, Personal
            Data may be part of the transferred assets.
          </li>
          <li>
            <span>Related Companies:</span> We may also share your Personal
            Data with our Related Companies for purposes consistent with this
            Privacy Policy.
          </li>
          <li>
            <span>Agents, Consultants and Related Third Parties:</span>{" "}
            Languex, like many businesses, sometimes hires other companies to
            perform certain business-related functions. Examples of such
            functions include mailing information, maintaining databases,
            shipping and fulfillment and processing payments. When we employ
            another company to perform a function of this nature, we only
            provide them with the information that they need to perform their
            specific function.
          </li>
          <li>
            <span>Legal Requirements:</span> Languex may disclose your
            Personal Data if required to do so by law or in the good faith
            belief that such action is necessary to (i) comply with a legal
            obligation, (ii) protect and defend the rights or property of
            Languex, (iii) act in urgent circumstances to protect the personal
            safety of users of the Site or the public, or (iv) protect against
            legal liability.
          </li>
        </ul>

        <h3>Exclusions</h3>
        <p>
          This Privacy Policy does not apply to any Personal Data collected by
          Languex other than Personal Data collected through the Site or
          services. This Privacy
          <br />
          Policy shall not apply to any unsolicited information you provide to
          Languex through this Site or through any other means. This includes,
          but is not limited to, information posted to any public areas of the
          Site, such as bulletin boards (collectively, “Public Areas”), any
          ideas for new products or
          <br />
          modifications to existing products, and other unsolicited submissions
          (collectively, “Unsolicited Information”). All Unsolicited Information
          shall be deemed to be non-confidential and Languex shall be free to
          reproduce, use, disclose, distribute and exploit such Unsolicited
          Information without limitation or attribution.
        </p>

        <h3>Underage Children</h3>
        <p>
          Languex does not knowingly collect Personal Data from children under
          the age of 13. If you are under the age of 13, please do not submit
          any Personal Data
          <br />
          through the Site. We encourage parents and legal guardians to monitor
          their children’s Internet usage and to help enforce our Privacy Policy
          by instructing their children never to provide Personal Data on this
          Site without their permission. If you have reason to believe that a
          child under the age of 13 has provided Personal Data to Languex
          through this Site, please contact us, and we will endeavor to delete
          that information from our databases.
        </p>

        <h3>Links to Other Web Sites</h3>
        <p>
          This Privacy Policy applies only to this Site. This Site may contain
          links to other web sites not operated or controlled by Languex (“Third
          Party Sites”). The
          <br />
          policies and procedures described here do not apply to the Third Party
          Sites. The links from this Site do not imply that Languex endorses or
          has reviewed the Third Party Sites. We suggest contacting those sites
          directly for information on their privacy policies.
        </p>

        <h3>Security</h3>
        <p>
          Languex takes reasonable steps to protect the Personal Data provided
          via the Site from loss, misuse, and unauthorized access, disclosure,
          alteration,
          <br />
          or destruction. However, no Internet, email or other electronic
          transmission is ever fully secure or error free, so you should take
          special care in deciding what information you send to us in this way.
        </p>

        <h3>Changes to Languex’s Privacy Policy</h3>
        <p>
          The Site and our business may change from time to time. As a result,
          at times it may be necessary for Languex to make changes to this
          Privacy Policy. Languex <br />
          reserves the right to update or modify this Privacy Policy at any time
          and from time to time without prior notice. Please review this policy
          periodically, and
          <br />
          especially before you provide any Personal Data. Your continued use of
          the Site after any changes or revisions to this Privacy Policy shall
          indicate your agreement with the terms of such revised Privacy Policy.
        </p>

        <h3>Access to Information Contacting Languex</h3>
        <p>
          To keep your Personal Data accurate, current, and complete, please
          contact us as specified below. We will take reasonable steps to update
          or correct Personal
          <br />
          Data in our possession that you have previously submitted via this
          Site or services. Please also feel free to contact us if you have any
          questions about Languex’s Privacy Policy or the information practices
          of this Site.
        </p>

        <div>
          <h3>Privacy</h3>
          <p>Policy or the information practices of this Site.</p>
        </div>

        <p>
          <span>Email:</span> ___________________
        </p>
      </div>
    </section>
  );
};

export default memo(TermsContent);
